import { Box, Button, Callout, Flex, Text } from "@radix-ui/themes";

export interface OrdersWidgetCancellationFeedback {
  color: "green" | "orange" | "red";
  message: string;
}

export interface OrdersCancellationPresentationProps {
  selectedCount: number;
  cancellationFeedback?: OrdersWidgetCancellationFeedback;
  isBatchCancelling: boolean;
  isWorkspaceSurface: boolean;
  onClearSelected?: () => void;
  onRequestBatchCancel?: () => void;
  onDismissCancellationFeedback?: () => void;
}

export const OrdersCancellationPresentation = ({
  selectedCount,
  cancellationFeedback,
  isBatchCancelling,
  isWorkspaceSurface,
  onClearSelected,
  onRequestBatchCancel,
  onDismissCancellationFeedback,
}: OrdersCancellationPresentationProps) => {
  const selectedOrderLabel = selectedCount === 1 ? "order" : "orders";
  const showBatchCancel = selectedCount > 0 && Boolean(onRequestBatchCancel);

  return (
    <>
      {cancellationFeedback ? (
        <Box px={isWorkspaceSurface ? "2" : undefined}>
          <Callout.Root
            color={cancellationFeedback.color}
            role={cancellationFeedback.color === "green" ? "status" : "alert"}
          >
            <Callout.Text>{cancellationFeedback.message}</Callout.Text>
            <Button
              type="button"
              size="1"
              variant="ghost"
              color={cancellationFeedback.color}
              onClick={onDismissCancellationFeedback}
              aria-label="Dismiss cancellation feedback"
            >
              Dismiss
            </Button>
          </Callout.Root>
        </Box>
      ) : null}

      {showBatchCancel ? (
        <Flex
          align="center"
          justify="between"
          gap="2"
          wrap="wrap"
          px="2"
          py="2"
          className="border-[color:var(--gray-a5)] border-b bg-[var(--accent-a2)]"
        >
          <Text size="1" color="gray" className="atd-numeric">
            {selectedCount} selected
          </Text>
          <Flex align="center" gap="1">
            <Button
              type="button"
              size="1"
              color="gray"
              variant="soft"
              disabled={isBatchCancelling}
              onClick={onClearSelected}
              aria-label="Clear selected orders"
            >
              Clear
            </Button>
            <Button
              type="button"
              size="1"
              color="red"
              disabled={isBatchCancelling}
              onClick={onRequestBatchCancel}
              aria-label={`Cancel ${selectedCount} ${selectedOrderLabel}`}
            >
              Cancel {selectedCount} {selectedOrderLabel}
            </Button>
          </Flex>
        </Flex>
      ) : null}
    </>
  );
};
